import { resolveMutationErrorMessage } from "@/shared/api/error-message";
import { resolveTosErrorKey } from "./error-codes";

/**
 * Compliance-domain wrapper around the shared mutation error
 * resolver. Backend's TOS errors carry a structured `errorCode` in the
 * body; when we recognise one we render the matching `compliance.errors.*`
 * key (so the operator sees the project's curated copy instead of a
 * raw `Server: ...`). Anything we don't recognise falls through to the
 * generic 401/403/4xx/5xx ladder.
 */
export function resolveComplianceError(
  err: unknown,
  t: (key: string, values?: Record<string, unknown>) => string,
): string {
  const known = resolveTosErrorKey(err);
  if (known) {
    return t(known.i18nKey, known.details ?? {});
  }
  return resolveMutationErrorMessage(err, t, {
    forbiddenKey: "compliance.errors.forbidden",
    serverPrefixKey: "compliance.errors.serverPrefix",
    genericKey: "compliance.errors.generic",
  });
}
